import { dataUsageArray } from './constants'
import { InfoBlock } from '../infoBlock'
import { useUnit } from 'effector-react'
import { $userLanguage } from '@/entities/user'
import { lang } from '@/shared/constants/lang'
import { useStyles } from './styles'
import { ViewType } from '@/features/errors'

// ===
// todo_ilian: this component is not reusable outside of gamed data usage context
// It's better to move it to gamedDataUsage folder
// ===

type ArrayKeys = {
  profile_information: string
  game_library: string
  playtime: string
  inventory: string
  privacy_first: string
}

export const DataUsageList = () => {
  const userLang = useUnit($userLanguage)

  const texts = lang[userLang].pages.authPage.data_using
  const { classes } = useStyles()
  return (
    <div className={classes.root}>
      {dataUsageArray.map((item) => (
        <InfoBlock
          key={item.key}
          width="100%"
          minHeight="96px"
          title={texts.titles[item.key as keyof ArrayKeys]}
          description={texts.descriptions[item.key as keyof ArrayKeys]}
          icon={item.key as ViewType}
        />
      ))}
    </div>
  )
}
